export enum UIEntityType {
  BLOCK = "block",
  INLINE_BLOCK = "inline_block",
  TEXT = "text",
  IMAGE = "image",
  VIDEO = "video",
  REWARDED_VIDEO_BUTTON = "rewardedVideoButton",
}
